import { render, staticRenderFns } from "./_bng.vue?vue&type=template&id=3a98b47c&lang=pug&"
import script from "./_bng.vue?vue&type=script&lang=js&"
export * from "./_bng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports